class MobileMenu {
    /**
     * Class constructor.
     *
     * Sets initial state of the mobile menu properties, then calls the `init` method to initialize the menu.
     */
    constructor() {
        this.isOpen = false;
        this.nav = null;
        this.triggers = [];
        this.header = null;
        this.body = null;

        this.init();
    }

    init() {
        this.nav = document.querySelector('[data-main-menu="menu"]');
        this.triggers = document.querySelectorAll('[data-main-menu="trigger"]');
        this.header = document.querySelector('.header');
        this.body = document.querySelector('body');

        if (!this.nav || !this.triggers.length) return;

        this.bindEvents();
    }

    /**
     * Binds event listeners for the mobile menu:
     * - Toggles the menu on trigger click.
     * - Closes the menu when clicking outside of it.
     * - Closes the menu on window resize if the viewport width exceeds 1024px.
     */
    bindEvents() {
        this.triggers.forEach((trigger) => {
            trigger.addEventListener('click', (e) => {
                e.stopPropagation();
                this.toggle();
            });
        });

        // document.addEventListener('click', (e) => {
        //     const clickedInsideTrigger = Array.from(this.triggers).some((trigger) => trigger.contains(e.target));
        //
        //     if (this.isOpen && !this.nav.contains(e.target) && !clickedInsideTrigger) {
        //         this.close();
        //     }
        // });

        window.addEventListener('resize', () => {
            if (window.innerWidth > 1024) {
                this.close();
            }
        });
    }

    /**
     * Toggles the mobile menu open or closed.
     *
     * If the menu is already open, this will close it. If the menu is already
     * closed, this will open it.
     *
     * @return {void}
     */
    toggle() {
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }

    /**
     * Opens the mobile menu.
     *
     * Sets {@link #isOpen} to true and updates the classes of the menu elements.
     *
     * @return {void}
     */
    open() {
        this.isOpen = true;
        this.updateClasses();
    }

    /**
     * Closes the mobile menu.
     *
     * Sets {@link #isOpen} to false and updates the classes of the menu elements.
     *
     * @return {void}
     */
    close() {
        this.isOpen = false;
        this.updateClasses();
    }

    /**
     * Updates the classes of the mobile menu elements based on the current state.
     *
     * If the menu is open, the following classes are added:
     * - `is-open` on the main menu element.
     * - `is-open` on the header element.
     * - `is-hidden` on the body element.
     *
     * If the menu is closed, the above classes are removed.
     *
     * Additionally, the `is-open` class is added to or removed from each of the
     * trigger elements.
     *
     * @return {void}
     */
    updateClasses() {
        const action = this.isOpen ? 'add' : 'remove';

        this.nav.classList[action]('is-open');
        this.header.classList[action]('is-open');
        this.body.classList[action]('is-hidden');

        this.triggers.forEach((trigger) => {
            trigger.classList[action]('is-open');
        });
    }
}

export default MobileMenu;
